<template>
  <svg
    version="1.1"
    id="レイヤー_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    :width="`${size}px`"
    :height="`${size}px`"
    viewBox="0 0 24 24"
    style="enable-background: new 0 0 24 24"
    xml:space="preserve"
  >
    <path
      id="パス_15"
      :style="{
        fill: colors[0],
      }"
      d="M22.3,20.2H1.7c-0.4,0-0.7-0.3-0.7-0.7v-16c0-0.4,0.3-0.7,0.7-0.7h20.6c0.4,0,0.7,0.3,0.7,0.7
	v16C23,19.9,22.7,20.2,22.3,20.2L22.3,20.2z M2.4,18.8h19.1V4.2H2.4V18.8z"
    />
    <rect
      id="長方形_82"
      x="14.1"
      y="3.5"
      :style="{
        fill: colors[0],
      }"
      width="8"
      height="16"
    />
  </svg>
</template>
<script>
  export default {
    name: 'machineInfo',
    props: {
      size: {
        type: Number,
        default: 20,
      },
      colors: {
        type: Array,
        default: () => ['#6F6F6F'],
      },
    },
  };
</script>
